import React, { useEffect } from 'react';
import PageContainer from '../../components/PageContainer/index';
import { Stack, Heading, Text } from 'chaser-components';
import BundleTable from './BundleTable/index';
import axios from 'axios';
import usePush from '../../hooks/usePush';

const Admin = () => {
  const { execute, response } = usePush(async () => {
    const { data } = await axios.get('https://quotes.rest/qod?language=en');
    return data.contents.quotes[0].quote;
  });

  useEffect(() => {
    execute();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <PageContainer>
      <Stack gap="medium" style={{ marginTop: '25px', marginBottom: '25px' }}>
        <Stack gap="small">
          <Heading>Admin</Heading>
          <Text color="Mid Neutral 1">{response}</Text>
        </Stack>
        <BundleTable />
      </Stack>
    </PageContainer>
  )
}

export default Admin;
